import { render, staticRenderFns } from "./UHeader.vue?vue&type=template&id=1c543134&scoped=true&"
import script from "./UHeader.vue?vue&type=script&lang=ts&"
export * from "./UHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UHeader.vue?vue&type=style&index=0&id=1c543134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c543134",
  null
  
)

export default component.exports